export const PLAN_ORDER = ["starter", "growth", "scale", "fund_manager"];

export const CAPABILITIES = [
  ["fundraising_crm", "Fundraising CRM pipeline"],
  ["round_modeling", "Round & dilution modeling"],
  ["cap_table", "Cap table"],
  ["deck_links", "Tracked deck links & analytics"],
  ["engagement_insights", "Engagement insights"],
  ["weekly_digest", "Weekly investor digest"],
  ["ai_qa", "AI-drafted investor Q&A"],
  ["editable_benchmarks", "Editable sweat-equity benchmarks"],
  ["data_rooms", "Data rooms with view tracking"],
  ["document_builder", "Document Builder + e-signatures"],
  ["funds", "Funds & SPVs"],
];

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;
export const aiLine = (p) => (p.ai_updates_per_month == null ? "Unlimited AI-drafted updates" : `${p.ai_updates_per_month} AI-drafted updates / month`);
export const fundsLine = (p) => (!p.funds ? null : p.max_funds == null ? "Unlimited funds & SPVs" : `${plural(p.max_funds, "fund or SPV")} included`);

export const featureLines = (plan, prev) => {
  if (!plan) return [];
  const lines = [];
  if (prev) lines.push(`Everything in ${prev.name}, plus`);
  lines.push(`Up to ${plan.investors.toLocaleString()} investors`);
  if (!prev || prev.ai_updates_per_month !== plan.ai_updates_per_month) lines.push(aiLine(plan));
  if (!prev) lines.push(...(plan.highlights || []));
  CAPABILITIES.forEach(([key, label]) => {
    if (key === "funds" || !plan[key] || (prev && prev[key])) return;
    lines.push(label);
  });
  if (plan.equity_pages > 0 && (!prev || prev.equity_pages !== plan.equity_pages)) lines.push(`${plan.equity_pages} employee equity pages`);
  const funds = fundsLine(plan);
  if (funds && (!prev || !prev.funds || prev.max_funds !== plan.max_funds)) lines.push(funds);
  if (prev) lines.push(...(plan.highlights || []));
  if (!prev || prev.team_seats !== plan.team_seats) lines.push(plural(plan.team_seats, "team seat"));
  return lines;
};

export const linesByPlan = (plans) => {
  const byKey = Object.fromEntries(plans.map((p) => [p.key, p]));
  return Object.fromEntries(PLAN_ORDER.map((key, i) => [key, featureLines(byKey[key], i ? byKey[PLAN_ORDER[i - 1]] : null)]));
};
